import React, { useState, useEffect,useRef,useCallback } from 'react'
import addProduct from '../../assets/image/PC200CE.png'
import { useHistory, useLocation } from 'react-router-dom';
import "./Compare.scss";
import axios from 'axios';
import Product from '../Product/Product';
import { findIndex } from 'lodash';
import { apiUrl } from '../../constants';
const Compare = () => {
    const history = useHistory();
    let { search } = useLocation();
    const [SpecGroups, setSpecGroups] = useState([])
    const [SpecKeys, setSpecKeys] = useState([])
    const [SpecValues, setSpecValues] = useState([])
    const [SpecValuesImages, setSpecValuesImages] = useState([])
    const sticky = useRef(null)
    const sticky_detail = useRef(null)
    const getGetSpecGroups = async () => {
        await axios.get(apiUrl+'/GetSpecGroups').then(async (response) => {
            // console.log(response.data)
            await setSpecGroups(response.data.data)
            return response.data.data
        })
    }
    const getGetSpecKeys = async () => {
        await axios.get(apiUrl+'/GetSpecKeys').then(async (response) => {
            let sort =  response.data.data.sort(function(a, b) {
                return parseFloat(a.specgroup_id) - parseFloat(b.specgroup_id);
            });
            await setSpecKeys(response.data.data)
            return response.data.data
        }).catch((error) => {
            return error
        })
    }
    const getGetSpecValue = async () => {
        var dataProductCompare = JSON.parse(localStorage.getItem('dataProductCompare'))
        const query = new URLSearchParams(search);
        const dataProductCompares = query.get('dataProductCompare')
        const CONVERTdataProductCompare = Array.from(dataProductCompares.split(','));
        const LI = await CONVERTdataProductCompare.map(async (data, i) => {
            const product = await axios.get(apiUrl+'/GetSpecValues?product_id=' + data).then(async (response) => {
                let dataProduct = response.data.data
                
                return { dataProduct}
            })
            return product
        })
        const propduct_items = await CONVERTdataProductCompare.map(async (data, i) => {
            const product_item = await axios.get(apiUrl+'/GetProduct?product_id='+data).then(async (response) => {
                return response.data.data
            })
            return product_item
        })
        localStorage.setItem("dataProductCompare", JSON.stringify(CONVERTdataProductCompare))
        let dataAll = await Promise.all(LI).then(function (results) {
            console.log(results) 
            return results
        })
        let img_path = await Promise.all(propduct_items).then(function (results) {
            // setSpecValues(results)
            return results
        })
        let dataAddimg = []
        let productfull = await img_path.map((img,i)=>{
            return img
        })
        setSpecValuesImages(productfull)
        setSpecValues(dataAll)

    }
    const mergeSpecGroupAndKeys = async () => {
        await getGetSpecGroups();
        await getGetSpecKeys();
        await getGetSpecValue();
    }
    const onAddProducts = async () => {
        var dataProductCompare = JSON.parse(localStorage.getItem('dataProductCompare'))
        let dataID = []
        const LI = await dataProductCompare.map(async (data, i) => {
            dataID.push(data)
            return dataID
        })
        window.location.href = `/callback?is_add_product=`+dataID
    }
    const getUrlParameter = (name) => {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        let results = regex.exec(window.location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };
    const removeProductCompare = async (index, product,product_img) => {
        var dataProductCompare = JSON.parse(localStorage.getItem('dataProductCompare'))
        console.log(product)
        const filteredProduct = SpecValues.filter((item) => item !== product);
        const filteredProducts = SpecValuesImages.filter((item) => item !== product_img);
        dataProductCompare = SpecValues.filter((item) => item !== product)
        let removeID = []
        await dataProductCompare.map((id,i)=>{
            removeID.push(id.dataProduct[0].productId)
        })
        console.log(removeID)
        setSpecValues(filteredProduct)
        setSpecValuesImages(filteredProducts)
        localStorage.setItem("dataProductCompare", JSON.stringify(removeID))
        // window.location.href = `/callback?is_remove_productID=`+1;
    }
    useEffect(() => {
        mergeSpecGroupAndKeys()
        
    }, [])
    const handleScroll = scroll => {
        sticky_detail.current.scrollLeft = scroll.target.scrollLeft;
        console.log(scroll.target.scrollLeft)
    }
    const handleScrollDetail = scroll => {
        sticky.current.scrollLeft = scroll.target.scrollLeft;
        console.log(scroll.target.scrollLeft)
    }
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col">
                    <div className="group_all_compare">
                        <div className="group_feature">
                            {
                            SpecValues.length < 3 ?  <div className="item add_items_feature" onClick={() => onAddProducts()}>
                                <div className='txt_btn'>
                                    <div className='icon-plus'>+</div>
                                    Add Product
                                </div>
                            </div> : <div className="item add_items_feature"></div>
                            }
                            {
                                SpecGroups.length != 0 && SpecGroups.map((specGroup, group_id) => {
                                    if (specGroup.groupname != null) {
                                        let fisrtArray = 0
                                        
                                        return (
                                            <>
                                                <div className="item header" key={group_id}>{specGroup.groupname}</div>
                                                {SpecKeys.map((specKey, i) => {
                                                    if (specKey.specgroup_id == specGroup.id && specKey.is_active) {
                                                        if (fisrtArray == 0) {
                                                            fisrtArray = 1
                                                            SpecKeys[i] = { ...specKey, first: 'top' }
                                                            return <div className="item top" key={i}>{specKey.key}</div>
                                                        }
                                                        return <div className="item" key={i}>{specKey.key}</div>
                                                    }
                                                })}
                                            </>
                                        )
                                    }
                                    return (
                                        <>
                                            {SpecKeys.map((specKey, speckey_id) => {
                                                if (specKey.specgroup_id == specGroup.id && specKey.is_active) {
                                                    return <div className="item" key={speckey_id}>{specKey.key}</div>
                                                }
                                            })}
                                        </>
                                    )

                                })
                            }
                        </div>
                        <div className="container_datail_compare">
                            <div className="sticky_compare" ref={sticky} onScroll={handleScroll}>
                                {
                                    SpecValues.length != 0 && SpecValues.map((specValue, products_index) => {
                                        return (
                                            <div className="box_img group_img_product">
                                                <a className="close_product" onClick={(i, data) => removeProductCompare(products_index, specValue,SpecValuesImages[products_index])}>+</a>
                                                <div className='img-product'>
                                                    <img src={SpecValuesImages[products_index].image_path}></img>
                                                </div>
                                                <div className='detail'>
                                                    <span className="name">{SpecValuesImages[products_index].machinename}</span>
                                                    <span className="subname">{SpecValuesImages[products_index].name}</span>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className='overlay-w'></div>
                            <div className="group-scroll"  ref={sticky_detail} onScroll={handleScrollDetail}>
                                {
                                    SpecValues.length != 0 && SpecValues.map((specValue, products_index) => {
                                        let fisrtArray = 0
                                        return (
                                            <div className='group_datail_compare' key={products_index}>
                                               
                                                {SpecKeys.map((specKey, i) => {
                                                    let keys = specValue.dataProduct.filter(x => x.key_id === specKey.id);
                                                    
                                                    if (SpecKeys[i] != undefined) {
                                                        if (SpecKeys[i].is_active) {
                                                            if(keys[0] != undefined){
                                                                if (SpecKeys[i].first == "top") {
                                                                    return  <div className="item top" key={i}>{keys[0] != undefined ? keys[0].value : ''}</div>
                                                                } else {
                                                                    return <div className="item" key={i}>{keys[0] != undefined ? keys[0].value : ''}</div>
                                                                }  
                                                            }
                                                        }
                                                    }
                                                })}

                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default Compare